export const platforms = {
    Shared: 0,
    Dashboard: 1,
    mobileApp: 2,
    WebSite: 3
};
